import Frontpage from '@/apps/frontpage/Frontpage.vue';
import ScheduleReport from '@/apps/report/ScheduleReport.vue';
import CodeSetStatisticsReport from '@/apps/report/CodeSetStatisticsReport.vue';
import UserProfile from '@/apps/userProfile/UserProfile.vue';
import LibraryList from '@/apps/codeLibrary/LibraryList.vue';
import LibraryNetwork from '@/apps/codeLibrary/LibraryNetwork.vue';
import CodeNetwork from '@/apps/codeLibrary/CodeNetwork.vue';
import CodeSet from '@/apps/codeLibrary/CodeSet.vue';
import Library from '@/apps/codeLibrary/Library.vue';
import Code from '@/apps/codeLibrary/Code.vue';
import Alias from '@/apps/config/Alias.vue';
import AdminCommands from '@/apps/config/AdminCommands.vue';
import ApplicationList from '@/apps/config/ApplicationList.vue';
import Application from '@/apps/config/Application.vue';
import Subscription from '@/apps/config/Subscription.vue';
import AccessGroupList from '@/apps/config/AccessGroupList.vue';
import AccessGroup from '@/apps/config/AccessGroup.vue';
import TabPolicySystemAndRoles from '@/apps/config/AccessPolicy/TabPolicySystemAndRoles.vue';
import TabUserAttributes from '@/apps/config/AccessPolicy/TabUserAttributes.vue';
import TabApplicationAttributes from '@/apps/config/AccessPolicy/TabApplicationAttributes.vue';
import TabLibraryPolicy from '@/apps/config/AccessPolicy/TabLibraryPolicy.vue';
import AttachmentSearch from '@/apps/config/AttachmentSearch.vue';
import ChangeLogAdmin from '@/apps/config/ChangeLogAdmin.vue';
import Monitoring from '@/apps/config/Monitoring.vue';
import Publisher from '@/apps/config/Publisher.vue';
import ScheduleList from '@/apps/config/ScheduleList.vue';
import TagsConfig from '@/apps/config/TagsConfig.vue';
import Webhooks from '@/apps/config/Webhooks.vue';
import UIDesignSystem from '@/apps/config/UIDesignSystem.vue';
import LogList from '@/shared/components/LogList.vue';
import ReleaseList from '@/apps/release/ReleaseList.vue';
import MyReleases from '@/apps/release/MyReleases.vue';
import MyReleaseArchive from '@/apps/release/MyReleaseArchive.vue';
import Release from '@/apps/release/Release.vue';
import Log from '@/apps/release/Log.vue';
import CodeSetImport from '@/apps/codeSetImport/CodeSetImport.vue';
import CableEditContainer from '@/apps/cableEdit/components/CableEditContainer.vue';
import EleComponentTypeContainer from '@/apps/eleComponentType/EleComponentTypeContainer.vue';
import ChangeLog from '@/apps/changeLog/ChangeLog.vue';
import PipeClassEditorPage from '@/apps/STID_Pipe/PipeClassEditorPage.vue';
import ProjectMasterContainer from '@/apps/facilityAndProject/ProjectMasterContainer.vue';
import FacilityContainer from '@/apps/facilityAndProject/FacilityContainer.vue';
import ProjectContainer from '@/apps/facilityAndProject/ProjectContainer.vue';
import ContractsContainer from '@/apps/facilityAndProject/ContractsContainer.vue';
import ProjectUI from '@/apps/project/ProjectUI.vue';
import SchemaContainer from '@/apps/schema/SchemaContainer.vue';
import SchemaDTO from '@/apps/schema/SchemaDTO.vue';
import SchemaList from '@/apps/schema/SchemaList.vue';
import SchemaModel from '@/apps/schema/views/SchemaModel.vue';
import SchemaClassEditor from '@/apps/schema/editors/SchemaClassEditor.vue';
import SchemaInterfaceEditor from '@/apps/schema/editors/SchemaInterfaceEditor.vue';
import SchemaAttributeEditor from '@/apps/schema/editors/SchemaAttributeEditor.vue';
import SchemaClassMappingEditor from '@/apps/schema/editors/SchemaClassMappingEditor.vue';
import SchemaRelationEditor from '@/apps/schema/editors/SchemaRelationEditor.vue';
import SchemaAttributeMappingEditor from '@/apps/schema/editors/SchemaAttributeMappingEditor.vue';
import SchemaRelationMappingEditor from '@/apps/schema/editors/SchemaRelationMappingEditor.vue';
import UnitOfMeasure from '@/apps/unitofmeasure/UnitOfMeasure.vue';
import CodeTables from '@/apps/report/CodeTables.vue';
import QueryReportMain from '@/apps/report/QueryReportMain.vue';
import UsageStatsMain from '@/apps/report/UsageStatsMain.vue';
import ClientApplications from '@/apps/report/ClientApplications.vue';
import ClientApplicationDetails from '@/apps/report/ClientApplicationDetails.vue';
import KpiMain from '@/apps/report/KpiMain.vue';
import UsageEventSearch from '@/apps/report/UsageEventSearch.vue';
import CorrelatedEventDetails from '@/apps/report/CorrelatedEventDetails.vue';
import LibraryCodeCount from '@/apps/report/LibraryCodeCount.vue';
import LsdMain from '@/apps/report/LsdMain.vue';
import MasterMapping from '@/apps/report/MasterMapping.vue';
import TreeMap from '@/apps/report/TreeMap.vue';
import Help from '@/apps/help/Help.vue';
import Lookup from '@/apps/lookup/Lookup.vue';
import Unauthorized from '@/shared/Unauthorized.vue';
import NoAccess from '@/shared/NoAccess.vue';
import SignInFailed from '@/shared/SignInFailed.vue';
import SqlEditor from '@/apps/sqlEditor/SqlEditor.vue';
import SqlResult from '@/apps/sqlResult/SqlResult.vue';
import EnsNumberValidation from '@/apps/ens/EnsNumberValidation.vue';
import EnsFormatEditor from '@/apps/ens/components/EnsFormatEditor.vue';
import DisabledFeatures from '@/apps/config/DisabledFeatures.vue';
import DisabledFeatureNotification from '@/shared/DisabledFeatureNotification.vue';
import Shipping from '@/apps/shipping/Shipping.vue';
import TabProjectMaster from '@/apps/facilityAndProject/TabProjectMaster.vue';
import TabFacilities from '@/apps/facilityAndProject/TabFacilities.vue';
import TabOrgUnits from '@/apps/facilityAndProject/TabOrgUnits.vue';
import TabProjects from '@/apps/facilityAndProject/TabProjects.vue';
import TabContracts from '@/apps/facilityAndProject/TabContracts.vue';
import CreateOrEditCode from '@/apps/facilityAndProject/CreateOrEditCode.vue';
import TRDocumentUI from '@/apps/trdocument/TRDocumentUI.vue';
import TRDocumentList from '@/apps/trdocument/TRDocumentList.vue';
import TRDocumentDetails from '@/apps/trdocument/TRDocumentDetails.vue';
import TRRevisionContentEditor from '@/apps/trdocument/TRRevisionContentEditor.vue';
import TRRevisionQueryTemplateList from '@/apps/trdocument/TRRevisionQueryTemplateList.vue';
import DocumentationBrowser from '@/apps/documentation/DocumentationBrowser.vue';
import DocumentationDocument from '@/apps/documentation/DocumentationDocument.vue';
import DocumentationTopic from '@/apps/documentation/DocumentationTopic.vue';

import { createRouter, createWebHistory } from 'vue-router';
import { redirectProjectMasterByGuid, roles } from './routerHelper.ts';
import { notFoundRoute } from './notFoundRoute.ts';

import { legacySchemaRoutes } from './schemaLegacyRoutes.ts';
import LibraryChangelog from '@/apps/codeLibrary/LibraryChangelog.vue';
import RecentStats from '@/apps/report/RecentStats.vue';

function decodeAmpersandsInQueryParameterNames(to) {
    // 2025-03-26
    // Some external system incorrectly replace the '&' between query parameters with '&amp;', see PR#1578, #1737
    // This fix replaces query parameters named 'amp;<name>' with '<name>', effectively decoding the ampersands before
    // continuing the route. This is only used for known problematic routes used by external systems,
    // and should not be activated elsewhere without team discussion.
    const newQuery = {};
    let hasChanged = false;
    for (const key in to.query) {
        if (key.substring(0, 4) === 'amp;') {
            newQuery[key.substring(4)] = to.query[key];
            hasChanged = true;
        } else {
            newQuery[key] = to.query[key];
        }
    }
    if (hasChanged) {
        to.query = newQuery;
        return to;
    }
}

export const routes = [
    {
        path: '/',
        name: 'FrontPage',
        component: Frontpage,
        meta: {
            title: 'Frontpage',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Library',
        name: 'LibraryList',
        component: LibraryList,
        meta: {
            title: 'Library List',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Library/Library-network',
        name: 'LibraryNetwork',
        component: LibraryNetwork,
        meta: {
            title: 'Library Network',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Library/Library-network/lib/:library',
        name: 'LibraryNetworkForLibrary',
        component: LibraryNetwork,
        meta: {
            title: 'Library Network',
            permissions: [roles.IsAuthenticatedUser]
        }

    },
    {
        path: '/Library/:libraryName',
        name: 'Library',
        component: Library,
        meta: {
            title: (route) => route.params.libraryName,
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        }
    },
    {
        path: '/Library/CodeSet/:codeSetName',
        name: 'CodeSet',
        component: CodeSet,
        meta: {
            title: 'CodeSet',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        },
        props: (route) => ({ codeSetName: route.params.codeSetName })
    },
    {
        path: '/Library/CodeSet/:codeSetName/code/:identity',
        name: 'codeOld',
        meta: {
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Library/code/:id',
        name: 'code',
        component: Code,
        meta: {
            title: 'Code',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        },
        props: (route) => ({ id: route.params.id })
    },
    {
        path: '/Library/Code-network/code/:dbId',
        name: 'CodeNetwork',
        component: CodeNetwork,
        meta: {
            title: 'Code Network',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        }
    },
    {
        path: '/Library/ChangeLog/',
        name: 'LibraryChangelog',
        component: LibraryChangelog,
        meta: {
            title: 'Changelog for all libraries',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/UserProfile',
        name: 'Userprofile',
        component: UserProfile,
        meta: {
            title: 'User Profile',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Config/AccessGroups',
        name: 'AccessGroups',
        component: AccessGroupList,
        meta: {
            title: 'Access Group Configuration',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/AccessGroups/:groupId',
        name: 'AccessGroupDetails',
        component: AccessGroup,
        meta: {
            title: 'Access Group',
            permissions: [roles.IsAdministrator]
        },
        props: (route) => ({ groupId: parseInt(route.params.groupId) })
    },
    {
        path: '/Config/AccessPolicy',
        name: 'AccessPolicy',
        meta: {
            title: 'Access Policy Configuration',
            permissions: [roles.IsAdministrator]
        },
        redirect: () => '/Config/AccessPolicy/LibraryPolicy',
        children: [
            {
                path: 'LibraryPolicy',
                name: 'LibraryPolicy',
                component: TabLibraryPolicy
            },
            {
                path: 'UserAttributes',
                name: 'UserAttributes',
                component: TabUserAttributes
            },
            {
                path: 'ApplicationAttributes',
                name: 'ApplicationAttributes',
                component: TabApplicationAttributes
            },
            {
                path: 'System',
                name: 'System',
                component: TabPolicySystemAndRoles
            }
        ]
    },
    {
        path: '/Config/AdminCommands',
        name: 'AdminCommands',
        component: AdminCommands,
        meta: {
            title: 'Admin commands',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/Aliasing',
        name: 'Aliasing',
        component: Alias,
        meta: {
            title: 'Aliases configuration',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/Application',
        component: ApplicationList,
        children: [
            {
                path: '',
                name: 'ApplicationList',
                component: ApplicationList,
                meta: {
                    title: 'Application configuration',
                    permissions: [roles.IsAdministrator]
                }
            },
            {
                path: ':appName',
                name: 'ApplicationDetails',
                components: {
                    default: ApplicationList,
                    applicationDetails: Application
                },
                meta: {
                    title: 'Application Configuration Details',
                    permissions: [roles.IsAdministrator]
                },
                props: {
                    applicationDetails: (route) => ({ appName: route.params.appName })
                }
            },
            {
                path: ':appName/:subscriptionId',
                name: 'SubscriptionDetails',
                components: {
                    default: ApplicationList,
                    applicationDetails: Subscription
                },
                meta: {
                    title: 'Subscription',
                    permissions: [roles.IsAdministrator]
                },
                props: (route) => ({ appName: route.params.appName, subscriptionId: route.params.subscriptionId })
            }
        ]
    },
    {
        path: '/Config/AttachmentSearch',
        name: 'AttachmentSearch',
        component: AttachmentSearch,
        meta: {
            title: 'Search for attachments',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Config/ChangeLogAdmin',
        name: 'ChangeLogAdmin',
        component: ChangeLogAdmin,
        meta: {
            title: 'ChangeLog Admin',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/DisabledFeatures',
        name: 'DisabledFeatures',
        component: DisabledFeatures,
        meta: {
            title: 'Disabled features',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/Monitoring',
        name: 'Monitor',
        component: Monitoring,
        meta: {
            title: 'Monitoring',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/Publisher',
        name: 'Publisher',
        component: Publisher,
        meta: {
            title: 'Publisher',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Config/Schedules',
        component: ScheduleList,
        meta: {
            title: 'Schedules',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/Tags',
        component: TagsConfig,
        meta: {
            title: 'Library Groups',
            permissions: [roles.IsAdministrator, roles.CanEditLibrary]
        }
    }, // did not bring the route :tag over because it did not look like it was in use.
    {
        path: '/Config/Webhooks',
        name: 'Webhooks',
        component: Webhooks,
        meta: {
            title: 'Webhooks configuration',
            permissions: [roles.IsAdministrator]
        },
        props: (route) => ({ hookId: route.query.hookId })
    },
    {
        path: '/Config/Webhooks/logs',
        name: 'WebhookLog',
        component: LogList,
        meta: {
            title: 'Webhook log',
            permissions: [roles.IsAdministrator]
        }
    },
    {
        path: '/Config/UI',
        name: 'UIDesignSystem',
        component: UIDesignSystem,
        meta: {
            title: 'UI Design System'
        }
    },
    {
        path: '/Release/',
        name: 'ReleaseList',
        component: ReleaseList,
        meta: {
            title: 'Common Library: All Releases',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Release/id/:release',
        name: 'ReleaseById',
        component: Release,
        meta: {
            title: 'Common Library: Release',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        }
    },
    {
        path: '/Release/MyReleases',
        name: 'MyReleases',
        component: MyReleases,
        meta: {
            title: 'Common Library: My Releases',
            permissions: [roles.IsAdministrator, roles.CanEditRelease]
        }
    },
    {
        path: '/Release/MyReleases/Archive',
        name: 'MyReleasesArchive',
        component: MyReleaseArchive,
        meta: {
            title: 'Common Library: My Release Archive ',
            permissions: [roles.IsAdministrator, roles.CanEditRelease]
        }
    },
    {
        path: '/Log',
        name: 'Log',
        component: Log,
        meta: {
            title: 'Log',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({
            libraryName: route.query.libraryName,
            applicationName: route.query.applicationName,
            codeSetName: route.query.codeSetName,
            releaseId: route.query.releaseId
        })
    },
    {
        path: '/CodeSetImport',
        name: 'CodeSetImport',
        component: CodeSetImport,
        meta: {
            title: 'Excel Import',
            permissions: [roles.CanEditRelease, roles.IsAdministrator]
        }
    },
    {
        path: '/CableEdit',
        redirect: () => {
            return { name: 'CableEditTab', params: { selectedTab: 'Code' } };
        }
    },
    {
        path: '/CableEdit/:selectedTab',
        name: 'CableEditTab',
        component: CableEditContainer,
        meta: {
            title: route => `Cable Edit: ${route.params.selectedTab}`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({
            selectedTab: route.params.selectedTab
        })
    },
    {
        path: '/EleComponentType',
        redirect: () => { return { name: 'ElectricComponentType' }; }
    },
    {
        path: '/ElectricComponentType',
        name: 'ElectricComponentType',
        component: EleComponentTypeContainer,
        meta: {
            title: 'Electrical Component Type',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/ChangeLog',
        name: 'ChangeLog',
        component: ChangeLog,
        meta: {
            title: 'ChangeLog - Common Library',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/TagFormat',
        name: 'TagFormat',
        component: EnsFormatEditor,
        meta: {
            title: 'Tag Format',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        },
        props: () => ({
            ensType: 'TagFormat'
        })
    },
    {
        path: '/DocumentNumberingFormat',
        name: 'DocumentNumberingFormat',
        component: EnsFormatEditor,
        meta: {
            title: 'Document Numbering Format',
            permissions: [roles.IsAuthenticatedUser],
            refreshKey: route => route.path
        },
        props: () => ({
            ensType: 'DocumentNumberingFormat'
        })
    },
    {
        path: '/EnsNumber',
        name: 'EnsNumber',
        component: EnsNumberValidation,
        meta: {
            title: 'ENS number validation',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/PipeClassEditor',
        redirect: () => { return { name: 'PipeClassEditor', params: { selectedTab: 'Class' } }; }
    },
    {
        path: '/PipeClassEditor/:selectedTab',
        name: 'PipeClassEditor',
        component: PipeClassEditorPage,
        meta: {
            title: 'Pipe Class Editor',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ selectedTab: route.params.selectedTab })
    },
    {
        path: '/FacilityAndProject',

        meta: {
            title: 'Facility and Project',
            permissions: [roles.IsAuthenticatedUser]
        },
        redirect: () => '/FacilityAndProject/projectmaster',
        children: [
            {
                path: 'projectmaster',
                name: 'ProjectMasterList',
                component: TabProjectMaster,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                },
                children: [
                    {
                        path: 'create',
                        name: 'CreateNewProjectMaster',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    }
                ]
            },
            {
                path: 'facility',
                name: 'FacilityList',
                component: TabFacilities,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                },
                children: [
                    {
                        path: 'create',
                        name: 'CreateNewFacility',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    }
                ]
            },
            {
                path: 'org-unit',
                name: 'OrgUnitList',
                component: TabOrgUnits,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                },
                children: [
                    {
                        path: 'create',
                        name: 'CreateNewOrgUnit',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    },
                    {
                        path: 'edit',
                        name: 'EditOrgUnit',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    }
                ]
            },
            {
                path: 'project',
                name: 'ProjectList',
                component: TabProjects,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                },
                children: [
                    {
                        path: 'create',
                        name: 'CreateNewProject',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    }
                ]
            },
            {
                path: 'contract',
                name: 'ContractList',
                component: TabContracts,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                },
                children: [
                    {
                        path: 'create',
                        name: 'CreateNewContract',
                        component: CreateOrEditCode,
                        meta: {
                            permissions: [roles.IsAuthenticatedUser]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/ProjectMaster/:guid',
        name: 'ProjectMasterByGuid',
        beforeEnter: redirectProjectMasterByGuid,
        meta: {
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/FacilityAndProject/by-id/:id',
        redirect: () => { return { name: 'FacilityAndProjectById' }; }
    },
    {
        path: '/FacilityAndProject/:id',
        name: 'FacilityAndProjectById',
        component: ProjectMasterContainer,
        meta: {
            title: 'Facility and Project',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ id: route.params.id })
    },
    {
        path: '/FacilityAndProject/facility/by-id/:id',
        redirect: () => { return { name: 'FacilityById' }; }
    },
    {
        path: '/FacilityAndProject/facility/:id',
        name: 'FacilityById',
        component: FacilityContainer,
        meta: {
            title: 'Facility and Project',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ id: route.params.id }),
        children: [
            {
                path: 'editFacility',
                name: 'EditFacility',
                component: CreateOrEditCode,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                }
            },
            {
                path: 'editProCoSys',
                name: 'EditProCoSys',
                component: CreateOrEditCode,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                }
            }
        ]
    },
    {
        path: '/FacilityAndProject/project/by-id/:id',
        redirect: () => { return { name: 'ProjectById' }; }
    },
    {
        path: '/FacilityAndProject/project/:id',
        name: 'ProjectById',
        component: ProjectContainer,
        meta: {
            title: 'Facility and Project',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ id: route.params.id }),
        children: [
            {
                path: 'edit',
                name: 'EditProject',
                component: CreateOrEditCode,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                }
            }
        ]
    },
    {
        path: '/FacilityAndProject/contract/by-id/:id',
        redirect: () => { return { name: 'ContractById' }; }
    },
    {
        path: '/FacilityAndProject/contract/:id',
        name: 'ContractById',
        component: ContractsContainer,
        meta: {
            title: 'Facility and Project',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ id: route.params.id }),
        children: [
            {
                path: 'edit',
                name: 'EditContract',
                component: CreateOrEditCode,
                meta: {
                    permissions: [roles.IsAuthenticatedUser]
                }
            }
        ]
    },
    {
        path: '/LCI/',
        name: 'Project',
        redirect: () => { return { name: 'LCITab', params: { tab: 'Projects' } }; }
    },
    {
        path: '/LCI/:tab',
        name: 'LCITab',
        component: ProjectUI,
        meta: {
            title: r => r.params.tab,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({
            tab: route.params.tab
        })
    },
    {
        path: '/Schema',
        name: 'SchemaList',
        component: SchemaList,
        meta: {
            title: 'Schema List',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    ...legacySchemaRoutes,
    {
        path: '/Schema/:identity/',
        name: 'SchemaDetails',
        component: SchemaContainer,
        meta: {
            title: (route) => `${route.params.identity} Details`,
            permissions: [roles.IsAuthenticatedUser]
        },
        redirect: () => ({ name: 'SchemaInfo' }),
        props: true,
        children: [
            {
                path: 'Info',
                name: 'SchemaInfo',
                component: SchemaContainer
            },
            {
                path: 'Classes',
                name: 'SchemaClasses',
                component: SchemaContainer,
                children: [
                    {
                        path: ':classIdentity',
                        name: 'SchemaClassDetails',
                        component: SchemaContainer
                    }
                ]
            },
            {
                path: 'Graph',
                name: 'SchemaGraph',
                component: SchemaContainer
            },
            {
                path: 'Issues',
                name: 'SchemaIssues',
                component: SchemaContainer
            }
        ]
    },
    {
        path: '/Schema/:identity/model/',
        name: 'SchemaModel',
        component: SchemaModel,
        meta: {
            title: (route) => `${route.params.identity} Model View`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/dto/',
        name: 'SchemaDTO',
        component: SchemaDTO,
        meta: {
            title: (route) => `${route.params.identity} Mapping`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/ClassEditor/',
        name: 'SchemaClass',
        component: SchemaClassEditor,
        meta: {
            title: (route) => `${route.params.identity} Class Editor`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/InterfaceEditor/',
        name: 'SchemaInterfaceEditor',
        component: SchemaInterfaceEditor,
        meta: {
            title: (route) => `${route.params.identity} Interface Editor`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/AttributeMappingEditor/',
        name: 'SchemaMapAttribute',
        component: SchemaAttributeMappingEditor,
        meta: {
            title: (route) => `${route.params.identity} Attribute Mapping`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/ClassMappingEditor/',
        name: 'SchemaMapClass',
        component: SchemaClassMappingEditor,
        meta: {
            title: (route) => `${route.params.identity} Class Mapping`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/RelationMappingEditor/',
        name: 'SchemaMapRelation',
        component: SchemaRelationMappingEditor,
        meta: {
            title: (route) => `${route.params.identity} Relation Mapping`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/AttributeEditor/',
        name: 'SchemaAttribute',
        component: SchemaAttributeEditor,
        meta: {
            title: (route) => `${route.params.identity} Attribute Editor`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Schema/:identity/RelationEditor/',
        name: 'SchemaRelation',
        component: SchemaRelationEditor,
        meta: {
            title: (route) => `${route.params.identity} Relation Editor`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ identity: route.params.identity })
    },
    {
        path: '/Sql',
        name: 'SqlEditor',
        component: SqlEditor,
        meta: {
            title: 'Sql Editor',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Sql/Library/:libraryName',
        name: 'SqlEditorByLibrary',
        component: SqlEditor,
        meta: {
            title: (route) => `Sql Editor (${route.params.libraryName})`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ requestedLibrary: route.params.libraryName })
    },
    {
        path: '/Sql/Saved/:guid',
        name: 'SqlEditorBySavedQuery',
        component: SqlEditor,
        meta: {
            title: 'Sql Editor',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ requestedSavedQueryGuid: route.params.guid })
    },
    {
        path: '/Sql/Result',
        name: 'SqlResult',
        component: SqlResult,
        beforeEnter: [decodeAmpersandsInQueryParameterNames],
        meta: {
            title: (route) => route.query.title || 'Sql Result',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Sql/Result/saved/:guid',
        name: 'SqlResultByGuid',
        component: SqlResult,
        beforeEnter: [decodeAmpersandsInQueryParameterNames],
        meta: {
            title: (route) => route.query.title || `Sql Result ${route.params.guid}`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ guid: route.params.guid })
    },

    {
        path: '/UoM',
        name: 'UnitOfMeasure',
        component: UnitOfMeasure,
        meta: {
            title: 'Unit of Measure',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/UoM/quantity/:quantityIdentity',
        name: 'Quantity',
        component: UnitOfMeasure,
        meta: {
            title: 'Quantity',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ quantityIdentity: route.params.quantityIdentity })
    },
    {
        path: '/CodeTables',
        name: 'CodeTablesExport',
        component: CodeTables,
        meta: {
            title: 'Export Code Tables',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/TreeMap',
        name: 'TreeMap',
        component: TreeMap,
        meta: {
            title: 'Library Tree map view',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Query',
        name: 'QueryReportMain',
        component: QueryReportMain,
        meta: {
            title: 'Query-based reports',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Query/guid/:guid',
        name: 'QueryReportByGuid',
        component: QueryReportMain,
        meta: {
            title: (route) => route.query.title || 'Query-based reports',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ guid: route.params.guid })
    },
    {
        path: '/Report/KPI',
        name: 'KPIReport',
        component: KpiMain,
        meta: {
            title: 'Key Performance Indicators',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Stats',
        name: 'Stats',
        component: UsageStatsMain,
        meta: {
            title: 'Usage statistics',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Stats/Recent',
        name: 'RecentStats',
        component: RecentStats,
        meta: {
            title: 'Recent usage statistics',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Stats/ClientApplications',
        name: 'ClientApplications',
        component: ClientApplications,
        meta: {
            title: 'Client applications',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Stats/ClientApplications/:userId',
        name: 'ClientApplicationDetails',
        component: ClientApplicationDetails,
        meta: {
            title: 'Client application details',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ userId: route.params.userId })
    },
    {
        path: '/Report/Stats/EventSearch',
        name: 'UsageEventSearch',
        component: UsageEventSearch,
        meta: {
            title: 'Usage event search',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Stats/EventSearch/:correlationId',
        name: 'CorrelatedEventDetails',
        component: CorrelatedEventDetails,
        meta: {
            title: 'Correlated event details',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ correlationId: route.params.correlationId })
    },
    {
        path: '/Report/LibraryCodeCount',
        name: 'LibraryCodeCount',
        component: LibraryCodeCount,
        meta: {
            title: 'Report: Library code count',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/LibraryScopeDistribution',
        name: 'LibraryScopeDistribution',
        component: LsdMain,
        meta: {
            title: 'Library Scope Distribution',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/LibraryStatistics',
        name: 'CodeSetStatisticsReport',
        component: CodeSetStatisticsReport,
        meta: {
            title: 'Library statistics',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/MasterMapping',
        name: 'MasterMapping',
        component: MasterMapping,
        meta: {
            title: 'Report: MasterMapping',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Report/Schedules',
        name: 'ScheduleReport',
        component: ScheduleReport,
        meta: {
            title: 'Report: Schedules',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Shipping',
        name: 'Shipping',
        component: Shipping,
        meta: {
            title: 'Shipping',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Help',
        name: 'Help',
        component: Help,
        meta: {
            title: 'Help',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Help/:slug',
        name: 'HelpSlug',
        component: Help,
        meta: {
            title: 'Help',
            permissions: [roles.IsAuthenticatedUser]
        },
        props: (route) => ({ slug: route.params.slug })
    },
    {
        path: '/Lookup',
        name: 'Lookup',
        component: Lookup,
        beforeEnter: [decodeAmpersandsInQueryParameterNames],
        meta: {
            title: 'Lookup',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Unauthorized',
        name: 'Unauthorized',
        component: Unauthorized,
        meta: {
            title: 'Access Denied',
            requireAuth: false
        },
        props: (route) => ({ page: route.params.page })
    },
    {
        path: '/NoAccess',
        name: 'NoAccess',
        component: NoAccess,
        meta: {
            title: 'No access',
            requireAuth: false
        }
    },
    {
        path: '/SignInFailed',
        name: 'SignInFailed',
        component: SignInFailed,
        meta: {
            title: 'Sign-in failed',
            requireAuth: false
        },
        props: (route) => ({ page: route.query.page })
    },
    {
        path: '/DisabledFeature',
        name: 'DisabledFeature',
        component: DisabledFeatureNotification,
        meta: {
            title: 'Disabled',
            requireAuth: false
        },
        props: route => ({ name: route.query.name })
    },
    {
        path: '/Documentation',
        name: 'DocumentationBrowser',
        component: DocumentationBrowser,
        meta: {
            title: 'Documentation',
            permissions: [roles.IsAuthenticatedUser]
        }
    },
    {
        path: '/Documentation/Topic/:identity',
        name: 'DocumentationTopic',
        component: DocumentationTopic,
        meta: {
            title: (route) => `Documentation topic ${route.params.identity}`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: route => ({ identity: route.params.identity })
    },
    {
        path: '/Documentation/Document/:identity',
        name: 'DocumentationDocument',
        component: DocumentationDocument,
        meta: {
            title: (route) => `Documentation: ${route.params.identity}`,
            permissions: [roles.IsAuthenticatedUser]
        },
        props: route => ({ identity: route.params.identity })
    },
    {
        path: '/TRDocument',
        component: TRDocumentUI,
        children: [
            {
                path: '',
                name: 'TRDocumentList',
                components: {
                    detailsView: TRDocumentList
                },
                meta: {
                    title: 'TR documents',
                    permissions: [roles.IsAuthenticatedUser]
                }
            },
            {
                path: 'Details/:trDocumentIdentity',
                name: 'TRDocumentDetails',
                components: {
                    detailsView: TRDocumentDetails
                },
                meta: {
                    title: (route) => `TR document: ${route.params.trDocumentIdentity}`,
                    permissions: [roles.IsAuthenticatedUser]
                },
                props: {
                    detailsView: (route) => ({ trDocumentIdentity: route.params.trDocumentIdentity })
                }
            },
            {
                path: 'Queries/:trDocumentIdentity',
                name: 'TRRevisionQueryTemplateList',
                components: {
                    detailsView: TRRevisionQueryTemplateList
                },
                meta: {
                    title: (route) => `TR query templates for ${route.params.trDocumentIdentity}`,
                    permissions: [roles.IsAuthenticatedUser]
                },
                props: {
                    detailsView: (route) => ({ trDocumentIdentity: route.params.trDocumentIdentity })
                }
            },
            {
                path: 'EditContent/:trDocumentIdentity?/:trRevisionIdentity?',
                name: 'TRRevisionContentEditor',
                components: {
                    detailsView: TRRevisionContentEditor
                },
                meta: {
                    title: 'TR revision content editor',
                    permissions: [roles.CanEditRelease]
                },
                props: {
                    detailsView: (route) => ({
                        trDocumentIdentity: route.params.trDocumentIdentity,
                        trRevisionIdentity: route.params.trRevisionIdentity
                    })
                }
            }
        ]
    },
    /*
        Lowest Priority Route
        Matches everything
        New routes must be added above
     */
    notFoundRoute
];

export const router = createRouter({
    history: createWebHistory(),
    routes
});
